import Button from "components/Inputs/Button";
import { CollectContext } from "pages/Collect";
import { FC, useContext, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { IConfigurationState } from "redux/configuration/configuration.interface";
import { setRewardValidation } from "redux/game/game.actions";
import Modal from "utils/hookedComponents/Modal";
import { useModal } from "utils/hookedComponents/Modal/core/modal.hook";
import ModalCollectDisclaimer from "../ModalCollectDisclaimer";
import { handleCTAClick } from "./core/modalCollectInstructions.helpers";
import { IProps } from "./core/modalCollectInstructions.types";
import { AppThunkDispatch } from "redux/configuration/configuration.types";
import { RewardValidationFailure } from "redux/game/game.interface";

const ModalCollectInstructions: FC<IProps> = ({ hideModal }) => {
  const [
    isModalCollectDisclaimerVisible,
    showModalCollectDisclaimer,
    hideModalCollectDisclaimer,
    referenceModalCollectDisclaimer,
  ] = useModal();
  const { t } = useTranslation("modals", { keyPrefix: "collect.instructions" });
  const { t: tModals } = useTranslation("modals");
  const { t: tHome } = useTranslation("home");
  const { reward } = useSelector((state: IConfigurationState) => state);
  const collectionPlace = reward?.cp;
  const toWhom = reward?.tw;
  const navigate = useNavigate();
  const { entityId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const collectContext = useContext(CollectContext);
  const { rewardId, companyId } = { ...collectContext };

  const dispatch: AppThunkDispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationFailure, setValidationFailure] =
    useState<RewardValidationFailure | null>(null);
  const [claimAttempt, setClaimAttempt] = useState(0);
  const lastSubmittedClaimAttempt = useRef<number | null>(null);

  const handleCodeClaim = async () => {
    if (
      !companyId ||
      !rewardId ||
      lastSubmittedClaimAttempt.current === claimAttempt
    ) {
      return;
    }

    lastSubmittedClaimAttempt.current = claimAttempt;
    setIsSubmitting(true);
    setValidationFailure(null);

    const result = await dispatch(setRewardValidation(companyId, rewardId));

    if (result.success === false) {
      setValidationFailure(result.error);
      setIsSubmitting(false);
      setClaimAttempt((currentAttempt) => currentAttempt + 1);
      return;
    }

    setTimeout(() => {
      navigate(
        `/${entityId}/collect-code/?rewardId=${rewardId}&token=${token}`
      );
    }, 1000);
  };

  const validationErrorKey =
    validationFailure === RewardValidationFailure.TEMPORARY
      ? "collect.disclaimer.temporaryError"
      : validationFailure
      ? `collect.${validationFailure}Collect.subtitle`
      : null;

  console.log("reward", reward);

  return (
    <div className="modal__content">
      <div className="modal__img">
        <img src="/static/images/modals/check-mark.png" alt="check emoji" />
      </div>
      <h2 className="modal__title">{t("title")}</h2>
      <p className="mb-2">
        <Trans
          ns="modals"
          i18nKey="collect.instructions.subtitle"
          components={[<span className="c-primary fw-700"></span>]}
        />
        <span className="c-primary fw-700">
          {t("collectionPlace", { collectionPlace })}
        </span>
      </p>
      {toWhom && (
        <p>
          <span>{t("subtitle2")}</span>
          <span className="c-primary fw-700">{t("toWhom", { toWhom })}</span>
        </p>
      )}
      <Button
        onClick={
          reward.code
            ? handleCodeClaim
            : handleCTAClick(showModalCollectDisclaimer)
        }
        text={
          validationFailure === RewardValidationFailure.TEMPORARY
            ? tHome("retryCTA")
            : t("CTA")
        }
        className="modal__btn mb-3"
        loading={isSubmitting}
        disabled={
          Boolean(validationFailure) &&
          validationFailure !== RewardValidationFailure.TEMPORARY
        }
      />
      {validationErrorKey && (
        <p role="alert" className="mb-2">
          {tModals(validationErrorKey)}
        </p>
      )}
      <Modal
        position="center"
        reference={referenceModalCollectDisclaimer}
        isVisible={isModalCollectDisclaimerVisible}
        content={
          <ModalCollectDisclaimer
            hideModal={hideModalCollectDisclaimer}
            hideModalCollectInstructions={hideModal}
          />
        }
      />
    </div>
  );
};

export default ModalCollectInstructions;
